export default function validate(data) {
    let errors = {};

    if (!data.firstName) {
        errors.firstName = 'firstName_error';
    }

    if (!data.lastName) {
        errors.lastName = 'lastName_error';
    }

    console.log(data.phone)

    if (!data.phone || data.phone.length < 5) {
        errors.phone = 'phone_error';
    }

    return errors
}
